import { AppMode } from 'app/features/settings/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { LocationType } from 'app/shared/features/location-selector/models';
import { ResultDeterminationType } from 'app/shared/models';
import { ComponentState } from 'app/state/manual-flow/select-state';

export function getStateBySupportedLocationType(locationType: LocationType) {
    return LocationType.Row === locationType ? ComponentState.SelectRow : ComponentState.SelectLocation;
}

export function skipEmployeeSelection(appMode?: AppMode) {
    return appMode === 'personal' ? ComponentState.CreateRegistration : ComponentState.SelectEmployee;
}

export function getResultDeterminationState(
    resultDeterminationType: ResultDeterminationType,
    appMode?: AppMode | undefined,
) {
    switch (resultDeterminationType) {
        case ResultDeterminationType.byOneContainer:
            return ComponentState.SelectContainer;
        case ResultDeterminationType.byContainer:
        case ResultDeterminationType.ByContainerAndProductBox:
            return ComponentState.SelectContainers;
        case ResultDeterminationType.byAmount:
            return ComponentState.SelectAmountResult;
        case ResultDeterminationType.byAmountAndProductBox:
            return ComponentState.SelectAmountAndProductBox;
        default:
            return skipEmployeeSelection(appMode);
    }
}

const isLocationSupported = (locationType: LocationType | null) =>
    locationType !== null && locationType !== LocationType.Site;

export function getLocationOrNextState(activity: Activity, appMode?: AppMode) {
    return isLocationSupported(activity.locationType)
        ? getStateBySupportedLocationType(activity.locationType)
        : getResultDeterminationState(activity.resultDeterminationType, appMode);
}

export function getLocationOrActivityState(activity: Activity) {
    return isLocationSupported(activity.locationType)
        ? getStateBySupportedLocationType(activity.locationType)
        : ComponentState.SelectActivity;
}
